import { render } from "./CollectionReportView.vue?vue&type=template&id=3e5b078b&scoped=true"
import script from "./CollectionReportView.vue?vue&type=script&lang=js"
export * from "./CollectionReportView.vue?vue&type=script&lang=js"

import "./CollectionReportView.vue?vue&type=style&index=0&id=3e5b078b&scoped=true&lang=less"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e5b078b"]])

export default __exports__